import React, { Suspense, lazy } from 'react';
import { Hero } from './Hero';
import { Story } from './Story';
import { Quotes } from './Quotes';
import { BookDetails } from './BookDetails';
import { Endorsements } from './Endorsements';
import { SpecialOffer } from './SpecialOffer';
// Lazy load the Footer since it's at the bottom of the page
const Footer = lazy(() => import('./Footer').then(module => ({
  default: module.Footer
})));
export const BookPromo = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-31">
      <Hero data-id="element-32" />
      <Story data-id="element-33" />
      <Quotes data-id="element-34" />
      <BookDetails data-id="element-35" />
      <Endorsements data-id="element-36" />
      <SpecialOffer data-id="element-37" />
      <Suspense fallback={null} data-id="element-38">
        <Footer data-id="element-39" />
      </Suspense>
    </div>;
};